import { render, staticRenderFns } from "./SettingArea.vue?vue&type=template&id=5df1c750&scoped=true"
import script from "./SettingArea.vue?vue&type=script&lang=js"
export * from "./SettingArea.vue?vue&type=script&lang=js"
import style0 from "./SettingArea.vue?vue&type=style&index=0&id=5df1c750&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5df1c750",
  null
  
)

export default component.exports